var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "42px",
    height: "42px",
    viewBox: "0 0 42 42",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "DA5E8095-086F-4CBD-9AFB-F1AE7670AB27") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("circle", {
    id: "path-1",
    cx: 11,
    cy: 11,
    r: 11
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-72.7%",
    y: "-54.5%",
    width: "245.5%",
    height: "245.5%",
    filterUnits: "objectBoundingBox",
    id: "filter-2"
  }, /*#__PURE__*/React.createElement("feMorphology", {
    radius: 2,
    operator: "dilate",
    in: "SourceAlpha",
    result: "shadowSpreadOuter1"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 4,
    in: "shadowSpreadOuter1",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "shadowBlurOuter1",
    in2: "SourceAlpha",
    operator: "out",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.207843137   0 0 0 0 0.262745098   0 0 0 0 0.329411765  0 0 0 0.299005682 0",
    type: "matrix",
    in: "shadowBlurOuter1"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Profile",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "T-Therapist-Profile-V1-Edits-A",
    transform: "translate(-918.000000, -313.000000)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "contact-+-language",
    transform: "translate(98.000000, 291.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon-edit",
    transform: "translate(830.000000, 28.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Oval"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-2)",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("circle", {
    stroke: "#FFFFFF",
    strokeWidth: 2,
    fill: "#354354",
    fillRule: "evenodd",
    cx: 11,
    cy: 11,
    r: 12
  })), /*#__PURE__*/React.createElement("path", {
    d: "M5.95310932,13.69431 L8.40376344,16.1449642 L5.94857527,16.8037814 C5.55135305,16.9103315 5.1878405,16.546819 5.29439068,16.1495968 L5.95310932,13.69431 Z M15.3382975,5.43543907 L16.5321326,6.62927419 C16.8760305,6.97317204 16.8760305,7.53076165 16.5321326,7.87475806 L9.27922939,15.1277599 L6.83981183,12.6883423 L14.0927151,5.43543907 C14.4367115,5.09144265 14.9943011,5.09144265 15.3382975,5.43543907 Z",
    id: "Combined-Shape",
    fill: "#FFFFFF"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconEdit);
export default __webpack_public_path__ + "static/media/icon-edit.0b6c1203a34ff61b5fcebc2d447789c1.svg";
export { ForwardRef as ReactComponent };